import React, { useState } from "react";
import { changePassword, checkOldPassword } from "../../api";
import { getUserDetails } from "../../utils/auth";
import { toast } from "react-toastify";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ChangePass = () => {
  const user = getUserDetails();
  const userId = Number(user?.userId);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [error, setError] = useState("");
  const [step, setStep] = useState<"VERIFY" | "CHANGE">("VERIFY");
  const [loading, setLoading] = useState(false);

  const handleVerify = async () => {
    setError("");
    if (!oldPassword) {
      setError("Old password is required.");
      return;
    }
    setLoading(true);
    try {
      await checkOldPassword(userId, oldPassword);
      setStep("CHANGE");
    } catch (err: any) {
      setError(err?.response?.data?.message || "Verification failed");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setError("");

    if (!newPassword) {
      setError("New password is required.");
      return;
    }
    if (newPassword.length < 6) {
      setError("New password must be at least 6 characters long.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("New passwords do not match.");
      return;
    }

    setLoading(true);
    try {
      await changePassword(userId, oldPassword, newPassword);
      toast.success("Password changed successfully!", {
        autoClose: 1000,
      });
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");
      setStep("VERIFY");
    } catch (err: any) {
      setError(err?.response?.data?.message || "Password change failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashboard-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="d-main-title">
              <h3>
                <i className="mx-2 fa-regular fa-address-card"></i>
                Change Password
              </h3>
            </div>
          </div>
          <div className="col-md-12">
            <div className="main-card mt-5">
              <div className="dashboard-wrap-content p-2">
                <div className="d-md-flex flex-wrap align-items-center justify-content-center">
                  <div className="dashboard-date-wrap mt-4">
                    <div className="form-group">
                      <div className="relative-input position-relative d-flex flex-column align-items-center gap-3">
                        <label className="form-label">Change Password</label>
                        <input
                          className="form-control h_40"
                          type="password"
                          placeholder="Current Password"
                          value={oldPassword}
                          onChange={(e) => setOldPassword(e.target.value)}
                          disabled={step === "CHANGE"}
                        />
                        {step === "VERIFY" && (
                          <button
                            onClick={handleVerify}
                            className="small-btn btn-hover mt-2"
                            disabled={loading}
                            style={{
                              borderRadius: "100px",
                              background:
                                "linear-gradient(to right,rgb(255, 101, 163),rgb(254, 163, 52))",
                            }}
                          >
                            {loading
                              ? "Verifying..."
                              : "Verify Current Password"}
                          </button>
                        )}
                        {step === "CHANGE" && (
                          <>
                            <input
                              className="form-control h_40"
                              type="password"
                              placeholder="New Password"
                              value={newPassword}
                              onChange={(e) => setNewPassword(e.target.value)}
                            />
                            <input
                              className="form-control h_40"
                              type="password"
                              placeholder="Confirm Password"
                              value={confirmPassword}
                              onChange={(e) =>
                                setConfirmPassword(e.target.value)
                              }
                            />
                            <button
                              onClick={handleSubmit}
                              className="small-btn btn-hover mt-2"
                              disabled={loading}
                              style={{
                              borderRadius: "100px",
                              background:
                                "linear-gradient(to right,rgb(255, 101, 163),rgb(254, 163, 52))",
                            }}
                            >
                              {loading ? "Updating..." : "Update Password"}
                            </button>
                          </>
                        )}
                        {error && (
                          <div className="text-danger mt-2">{error}</div>
                        )}
                      </div>
                      <div>
                        <ToastContainer />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePass;
